import React from 'react';
import { modal } from 'react-modal-dom';

// modal
import MyBigModal from './MyBigModal';
import MyModalInModal from './MyModalInModal';
import MyScrollModal from './MyScrollModal';
import MySmallModal from './MySmallModal';

const App = () => {
  return (
    <div className="body">
      <img src="/emoji.png" alt="" />
      <div className="content">
        <h1>Lightweight and customizable modal with react</h1>
        <p>
          We do not limit you with html markup. You can create modal windows of
          absolutely any format and manage them from anywhere in your react
          application.
        </p>
      </div>

      <div className="grid">
        <button
          className="button"
          type="button"
          style={{ background: 'linear-gradient(-44deg,#f5f0ff,#fff8fb)' }}
          onClick={() => modal.open(<MySmallModal />)}
        >
          Open small modal
        </button>

        <button
          className="button"
          type="button"
          style={{
            background:
              'linear-gradient(-45deg,rgba(244,249,250,.85),rgba(237,243,253,.85))',
          }}
          onClick={() => modal.open(<MyBigModal />)}
        >
          Open large modal
        </button>

        <button
          className="button"
          type="button"
          style={{
            background:
              'linear-gradient(-42deg,rgba(251,245,238,.85),rgba(246,243,245,.85))',
          }}
          onClick={() => modal.open(<MyScrollModal />)}
        >
          Open modal with croll
        </button>

        <button
          className="button"
          type="button"
          style={{
            background:
              'linear-gradient(-47deg,rgba(253,247,241,.85),rgba(227,247,248,.85))',
          }}
          onClick={() => modal.open(<MyModalInModal />)}
        >
          Open modal from modal
        </button>
      </div>

      <ul className="links">
        <li>
          <a href="https://github.com/iMykhailychenko/react-modal-dom" title="github" target="_blank" rel="noopener noreferrer">
            <img src="/github.png" alt="github"/>
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/profile.php?id=100005827514352" title="facebook" target="_blank" rel="noopener noreferrer">
            <img src="/facebook.png" alt="facebook"/>
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/in/ihor-mykhailychenko-755778160/" title="linkedin" target="_blank" rel="noopener noreferrer">
            <img src="/linkedin.png" alt="linkedin"/>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default App;
